import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { setMessage } from './message';

import secondWeightEntryService from '../services/second-weight-entry.service';


export const fetchSecondWeightEntryList = createAsyncThunk(
    'secondWeightEntry/fetchSecondWeightEntryList',
    async ({ page, pagesize, search, ordering }, thunkAPI) => {
        try {
            const response = await secondWeightEntryService.getSecondWeightEntryList(page, pagesize, search, ordering);
            return response.data;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    },
);

export const fetchArchivedSecondWeightEntrylist = createAsyncThunk(
    'secondWeightEntry/fetchArchiveSecondWeightEntryList',
    async ({ page, pagesize, search, ordering }, thunkAPI) => {
        try {
            const response = await secondWeightEntryService.getArchiveSecondWeightEntryList(page, pagesize, search, ordering);
            return response.data;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    },
);
export const fetchSecondWeightEntryDetails = createAsyncThunk(
    'secondWeightEntry/fetchSecondWeightEntryDetails',
    async (id, { rejectWithValue }) => {
        try {
            const response = await secondWeightEntryService.getSecondWeightEntryDetails(id);
            return response.data; // Return the profile data
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);
export const fetchSecondWeightEntryById = createAsyncThunk(
    'secondWeightEntry/fetchSecondWeightEntryById',
    async (secondWeightEntryId, { rejectWithValue }) => {
        try {
            const response = await secondWeightEntryService.getSecondWeightEntryById(secondWeightEntryId);
            return response.data; // Return the profile data
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);


export const createSecondWeightEntry = createAsyncThunk(
    'secondWeightEntry/createSecondWeightEntry',
    async ({ values }, thunkAPI) => {
        try {
            const textPayload = {
                party_name: values.party_name,
                party_code: values.party_code,
                opening_balance: values.opening_balance,
                balance_type: values.balance_type,
                is_this_cash_account: values.is_this_cash_account || false,
                address: values.address,
                city: values.city,
                pincode: values.pincode,
                mobile_sms: values.mobile_sms,
                mobile: values.mobile,
                phone: values.phone,
                email: values.email,
                sms_type: values.sms_type,
                is_active: values.is_active || false,
              };
              
            const response = await secondWeightEntryService.addSecondWeightEntry(textPayload);
            return response.data; // Assuming response contains the created secondWeightEntry data
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const updateSecondWeightEntry = createAsyncThunk(
    'secondWeightEntry/updateSecondWeightEntry',
    async ({ id, values }, thunkAPI) => {
        try {
            const formPayload = {
                party_name: values.party_name,
                party_code: values.party_code,
                opening_balance: values.opening_balance,
                balance_type: values.balance_type,
                is_this_cash_account: values.is_this_cash_account || false,
                address: values.address,
                city: values.city,
                pincode: values.pincode,
                mobile_sms: values.mobile_sms,
                mobile: values.mobile,
                phone: values.phone,
                email: values.email,
                sms_type: values.sms_type,
                is_active: values.is_active || false,
            };

            const response = await secondWeightEntryService.updateSecondWeightEntry(id, formPayload);

            return response.data; // Return the updated secondWeightEntry data
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const deleteSecondWeightEntry = createAsyncThunk(
    'secondWeightEntry/deleteSecondWeightEntry',
    async (id, thunkAPI) => {
        try {
            await secondWeightEntryService.deleteSecondWeightEntry(id); // Ensure `id` is used here
            return id; // Return the ID of the deleted group
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const unArchiveSecondWeightEntry = createAsyncThunk(
    'secondWeightEntry/unArchiveSecondWeightEntry',
    async (id, thunkAPI) => {
        try {
            await secondWeightEntryService.unArchiveSecondWeightEntryRecord(id); // Ensure `id` is used here
            return id; // Return the ID of the deleted group
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);

const initialState = {
    data: [], // List
    list: [],
    toolsList: [],
    loading: false,
    totalPages: 0,
    currentPage: 1,
    totalRecord: 0,
    status: 'idle',
    error: null,
    hasMore: true,
};


const secondWeightEntrySlice = createSlice({
    name: 'secondWeightEntry',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        resetSecondWeightEntryData: (state) => {
            state.data = []; // This will clear the list
        },
        resetSecondWeightEntryList: (state) => {
            state.list = []; // This will clear the list
        },
        // resetToolsList: (state) => {
        //     state.toolsList = []; // This will clear the list
        // },
        resetCurrentSecondWeightEntryPage: (state) => {
            state.currentPage = 1;
        }
    },
    extraReducers: builder => {
        builder
            .addCase(fetchSecondWeightEntryList.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchSecondWeightEntryList.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const fetchedPage = action.payload.page || state.currentPage;
                state.data = action.payload.results.data || [];
                state.totalPages = action.payload.totalPages;
                state.totalRecord = action.payload.count;
                state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
                state.list = [...state.list, ...action.payload.results.data];
                state.hasMore = !!action.payload.next;
            })
            .addCase(fetchSecondWeightEntryList.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.error.message;
            });
        builder
            .addCase(fetchArchivedSecondWeightEntrylist.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchArchivedSecondWeightEntrylist.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const fetchedPage = action.payload.page || state.currentPage;
                state.data = action.payload.results.data || [];  // Update to match your API response
                state.totalRecord = action.payload.count || 0; // Handle count (total records)
                state.totalPages = action.payload.totalPages || 0; // Handle totalPages
                state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
                state.list = [...state.list, ...action.payload.results.data];
                state.hasMore = !!action.payload.next;
            })
            .addCase(fetchArchivedSecondWeightEntrylist.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
            });

        builder
            .addCase(fetchSecondWeightEntryDetails.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchSecondWeightEntryDetails.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(fetchSecondWeightEntryDetails.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });

        builder
            .addCase(fetchSecondWeightEntryById.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchSecondWeightEntryById.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(fetchSecondWeightEntryById.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });


        builder
            .addCase(createSecondWeightEntry.pending, state => {
                state.status = 'loading';
            })
            .addCase(createSecondWeightEntry.fulfilled, (state, action) => {
                state.status = 'succeeded';
            })
            .addCase(createSecondWeightEntry.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });
        builder
            .addCase(updateSecondWeightEntry.pending, state => {
                state.status = 'loading';
            })
            .addCase(updateSecondWeightEntry.fulfilled, (state, action) => {
                state.status = 'succeeded';
            })
            .addCase(updateSecondWeightEntry.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });
        builder
            .addCase(deleteSecondWeightEntry.pending, state => {
                state.status = 'loading';
            })
            .addCase(deleteSecondWeightEntry.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = state.data.filter(group => group.id !== action.payload); // Remove the deleted group from state
                state.list = state.list.filter(group => group.id !== action.payload); // Remove the deleted group from list
            })
            .addCase(deleteSecondWeightEntry.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.payload;
            });
        builder
            .addCase(unArchiveSecondWeightEntry.pending, state => {
                state.status = 'loading';
            })
            .addCase(unArchiveSecondWeightEntry.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = state.data.filter(group => group.id !== action.payload); // Remove the deleted group from state
            })
            .addCase(unArchiveSecondWeightEntry.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export const { resetSecondWeightEntryList, resetSecondWeightEntryData,  resetCurrentSecondWeightEntryPage } = secondWeightEntrySlice.actions;
const { reducer } = secondWeightEntrySlice;
export default reducer;
